import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import MainImageCardDashboard from '../../../components/Cards/MainImageCardDashboard';
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import VaccinesIcon from '@mui/icons-material/Vaccines';
import { microbes } from "../../../constants";


export default function ImmuneCard() {

return (
<>

    <MainImageCardDashboard

        content = {<HeaderCardSmall cardheadline={'Immunity Health'} /> }

        iconbuttons = {<>               

                        <Tooltip title="Immune System Health" placement="bottom">
                                <IconButton component={RouterLink} to="/ImmuneWelcome"  size="large">
                                        <VaccinesIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
                                </IconButton>
                        </Tooltip>               
                 </>}  

        photo = { microbes }  

    />

</>
)};
